import PicklistMetadata from "../PicklistMetadata";

// Non-static picklist over the RelationshipType EC (display = Name, value = USID) — used to pick
// the type of an Enterprise Term relationship.
//
// SCOPED TO TERMS. One vocabulary serves every object with relationships, so without this the
// glossary would offer "Supersedes" and "Stricter than" between two business terms — types written
// for rules and meaningless here. See RuleRelationshipTypePicklistMetadata for the other half.
class RelationshipTypePicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "RelationshipType";
        this.static = false;
        this.enterpriseComponent = "RelationshipType";
        this.useRealm = false;
        // Consumed by RelationshipTypeEnterpriseComponent.performQuery as an EQUAL QBE member,
        // against the IDOC tag "ObjectType".
        this.searchSpecification = {"ObjectType": "EnterpriseTerm"};
        this.sortSpecification = {"Name": "ASC"};
        this.typeField = "Name";
        this.typeValue = "USID";
        this.allowNoSelection = false;
    }
}

export default RelationshipTypePicklistMetadata;
